import firebase from '../firebase';

export const setConvoCode = (convoCode) => ({
    type: 'SET_CONVO_CODE',
    convoCode
}); 

export const addMessage = (msg) => ({
    type: 'ADD_MESSAGE',
    ...msg
}); 

export const sendMessage = (convoCode, text, user, emotion) => {
    return function (dispatch) {
        let msg = {
                text: text,
                time: Date.now(),
                author: {
                    name: user.name,
                    id: user.id
                },
                emotion: emotion
            };

        const newMsgRef = firebase.database()
                                  .ref('messages/'+convoCode)
                                  .push();
        msg.id = newMsgRef.key;
        newMsgRef.set(msg);

        console.log("MESSAGE IN SENDMESSAGE:", msg);

        dispatch(addMessage(msg));
    };
};

export const setAlert = (alert, msg) => {
    return function (dispatch) {
        dispatch(setStateAlert(alert));
    }
}

export const setStateAlert = (alert) => ({
    type: 'SET_ALERT',
    alert
});

export const addScript = (script) => ({
    type: 'ADD_SCRIPT',
    script
});

export const startFetchingMessages = () => ({
    type: 'START_FETCHING_MESSAGES'
});

export const receivedMessages = () => ({
    type: 'RECEIVED_MESSAGES',
    receivedAt: Date.now()
});

export const fetchMessages = (convoCode) => {
    return function (dispatch) {
        dispatch(startFetchingMessages());

        firebase.database()
                .ref('messages/' + convoCode)
                .on('child_added', (snapshot) => {
                    const messages = snapshot.val() || [];
                    console.log("messages fetched", messages);
                    dispatch(receiveMessages(messages));    
                }, 0);
    }
}

export const fetchScriptBar = () => {
    return function (dispatch) {
        dispatch(startFetchingScripts());

        firebase.database()
                .ref('scripts/')
                .orderByKey()
                .on('value', (snapshot) => {
                    setTimeout(() => {
                        const script = snapshot.val() || [];
                        dispatch(receiveScripts(script));
                    }, 0);
                });
    }
}

export const startFetchingScripts = () => ({
    type: 'START_FETCHING_SCRIPTS'
});

export const receivedScripts = () => ({
    type: 'RECEIVED_SCRIPTS'
});

export const receiveScripts = (script) => {
    return function (dispatch) {
        dispatch(addScript(script.currentScript.text));
        dispatch(receivedScripts());
    }
}

export const receiveMessages = (msg) => {
    return function (dispatch) {
        console.log("MESSAGE IN RECEIVEMESSAGES", msg);
        dispatch(addMessage(msg));

        dispatch(receivedMessages());
    };
};

export const promptFeedback = () => ({
    type: 'PROMPT_FEEDBACK'
});

/* User actions */ 
export const setUserName = (name) => ({
    type: 'SET_USER_NAME',
    name
});

export const setUserRole = (role) => ({
    type: 'SET_USER_ROLE',
    role
});

export const setGuestList = (guestList) => ({
    type: 'SET_GUEST_LIST',
    guestList
});

export const getGuests = () => {
    return function (dispatch) {
        let today = new Date().toDateString();
        firebase.database()
                .ref(`users/`)
                .orderByChild(`convoDate`)
                .equalTo(today)
                .once('value', (snapshot) => {
                    let guestList = [];
                    snapshot.forEach((childSnapshot) => {
                        if (childSnapshot.val().role == "guest") {
                            guestList.push(childSnapshot.val().name);
                        }
                    });
                    dispatch(setGuestList(guestList));
                });
    };
};

export const login = (convoCode) => {
    return function (dispatch, getState) {
        dispatch(startAuthorizing());

        firebase.auth()
                .signInAnonymously()
                .then(() => {
                    const user = getState().user;
                    const name = user.name;
                    const convoDate = user.convoDate;
                    const role = user.role;
                    const finished = false;
                    
                    firebase.database()
                            .ref(`users/`)
                            .child(name)
                            .set({
                                name,
                                convoDate,
                                role,
                                convoCode,
                                finished
                            });


                    startChatting(dispatch, convoCode);
                });
    };
};

export const checkUserExists = (convoCode) => {
    return function (dispatch) {
        dispatch(startAuthorizing());

        firebase.auth()
                .signInAnonymously()
                .then(() => firebase.database()
                                    .ref(`users/`)
                                    .once('value', (snapshot) => {
                                        const val = snapshot.val();

                                        if (val === null) {
                                            dispatch(userNoExist());
                                        }else{
                                            dispatch(setUserName(val.name));
                                            startChatting(dispatch, convoCode);
                                        }
                                    }))
                .catch(err => console.log(err))
    };
};

const startChatting = function (dispatch, convoCode) {
    dispatch(userAuthorized());
    dispatch(setUserConvo(convoCode));
    dispatch(fetchMessages(convoCode));
    dispatch(fetchScriptBar());
}

export const setUserConvo = (convoCode) => ({ 
    type: 'SET_USER_CONVO',
    convoCode
 });

export const startAuthorizing = () => ({
    type: 'USER_START_AUTHORIZING'
});

export const userAuthorized = () => ({
    type: 'USER_AUTHORIZED'
});

export const userNoExist = () => ({
    type: 'USER_NO_EXIST'
});

/* Moderator actions */
export const sendScript = (text) => {
    return function(dispatch) {
        // Add script to database
        firebase.database()
                .ref(`scripts/`)
                .child(`currentScript`)
                .set({
                    text
                });
    
        // Dispatch add script
        dispatch(addScript(text));
    };
};

export const noLinks = () => ({
    type: 'SET_LINKS_FALSE'
});

export const addLinks = (articleA, articleB) => ({
    type: 'ADD_LINKS',
    articleA,
    articleB
});

export const sendLinks = (articleA, articleB) => {
    return function(dispatch) {
        dispatch(addLinks(articleA, articleB));
    }
};

export const sendHelpScript = (choice) => ({
    type: 'GENERATE_HELP_SCRIPT',
    choice
});

export const checkConversation = (convoCode) => {
    return function(dispatch) {
        firebase.database()
        .ref('users/')
        .orderByChild('convoCode')
        .equalTo(convoCode)
        .on('child_added', (snapshot) => {
            const children = snapshot.val() || [];
            console.log("children being fetched", children);
            dispatch(endConversation(children.finished));
        });

    }
};

export const signalEndConversation = (convoCode) => {
    return function(dispatch) {
        firebase.database()
                .ref('users/')
                .orderByChild('convoCode')
                .equalTo(convoCode)
                .on('child_added', (snapshot) => {
                    const children = snapshot.val() || [];
                    console.log("children fetched", children);

                    firebase.database()
                            .ref(`users/`)
                            .child(children.name)
                            .set({
                                name: children.name,
                                convoDate: children.convoDate,
                                role: children.role,
                                convoCode: children.convoCode,
                                finished: true
                            });
                    dispatch(endConversation(true));  
                }, 0);

    }
};

export const endConversation = (endConversation) => ({
    type: 'END_CONVERSATION',
    endConversation
});


// WEBPACK FOOTER //
// ./src/actions/index.js